import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import Select from "../Select"

export const OptionsCauseOfIncident = [
    {
        id: 12,
        label: "Invalidez por acidente",
        value: 12,
    },
    {
        id: 11,
        label: "Invalidez por doença",
        value: 11,
    },
]

const SelectCauseIncidentInputMIPInsured = () => {
    const { control, formState: { errors } } = useFormContext()
    return (
        <Controller
            name="SelectCauseIncident"
            control={control}
            render={({ field }) => (
                <Select
                    id="SelectCauseIncident"
                    name="SelectCauseIncident"
                    title="Causa do ocorrido"
                    placeholder="Escolha"
                    options={OptionsCauseOfIncident}
                    value={field.value?.value}
                    selected={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                    hasError={errors?.Email?.message}
                    errorMessage={errors?.SelectCauseIncident?.message}
                    isRequired
                    {...field}
                />
            )}
        />
    )
}

export default SelectCauseIncidentInputMIPInsured

